<template>
  <main class="main" id="main">
    <div class="top_line">
      <div class="container">
        <h1>Заказ пиццы</h1>
      </div>
    </div>
    <section class="section s-seo">
      <div class="container">
        <div class="seo_box">
          <div class="item">
            <h2 style="margin-top:2%;">Заказ пиццы в г.{{city.name}}</h2>
            <p style="margin-top:2%;">Самая вкусная пицца ждет Вас на нашем сайте. Выбери любую понравившуюся пиццу в одном из 1000 ресторанов на <router-link to="/">хочу-поесть.рф</router-link>. Бесплатная круглосуточная доставка пиццы в вашем городе домой или в офис.</p>
            <p><b>Пицца</b> – одно из самых популярных блюд по всему миру. Вы можете заказать Четыре сыра, Европейскую, Барбекю, Пепперони, Маргариту или собрать пиццу сами.</p>
            <center><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/global/articles/pizza1.jpg" alt="Заказ пиццы" width="700" /></center>
            <h2 style="margin-top:2%;">Сделать заказ пиццы можно за 2 минуты</h2>
            <p> - Выбирайте пиццу или любимый ресторан</p>
            <p> - Делайте заказ пиццы и напитков</p>
            <p>И наш курьер уже у ваших дверей! А сам заказ Вы можете оплатить бонусными долларами и получить реальный кэш-бэк.</p>
            <p>А может хочется чего-то другого? <router-link to="/product/1">Закажите роллы и суши</router-link>, <router-link to="/product/25">бургеры</router-link> или <router-link to="/pie">пироги</router-link>.</p>
            <p>Хотите приготовить пиццу сами? Оригинальные рецепты пиццы для Вас специально подготовили шеф-повара лучших ресторанов вашего города.</p>
            <router-link :to="'/product/2'" tag="div">
              <button class="menu_item_btn seo">ХОЧУ ПОЕСТЬ!</button>
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'pizza',
  props: ['city']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/articles/pizza.vue